<template>

  <KCardGrid
    layout="1-2-3"
    :skeletonsConfig="skeletonsConfig"
    :loading="loading"
  >
    <Card
      :headingLevel="4"
      orientation="vertical"
      thumbnailDisplay="none"
      prependTitle="(1)"
    />
    <Card
      :headingLevel="4"
      orientation="vertical"
      thumbnailDisplay="none"
      prependTitle="(2)"
      showProgressInFooter
    >
      <template #footer>
        <span></span>
      </template>
    </Card>
    <Card
      :headingLevel="4"
      orientation="vertical"
      thumbnailDisplay="none"
      prependTitle="(3)"
      showMenuInFooter
    />
  </KCardGrid>

</template>


<script>

  import Card from './Card';

  export default {
    components: {
      Card,
    },
    props: {
      /**
       * How long in seconds to simulate loading
       * state before displaying cards
       */
      loadFor: {
        type: Number,
        default: 3,
      },
    },
    data() {
      return {
        loading: this.loadFor > 0,
        skeletonsConfig: [
          {
            breakpoints: [0, 1, 2, 3, 4, 5, 6, 7],
            orientation: 'vertical',
            thumbnailDisplay: 'large',
            minHeight: '490px',
          },
          {
            breakpoints: [3, 4, 5, 6, 7],
            minHeight: '420px',
          },
        ],
      };
    },
    mounted() {
      if (this.loadFor > 0) {
        setTimeout(() => {
          this.loading = false;
        }, this.loadFor * 1000);
      }
    },
  };

</script>


<style scoped>

  .pills {
    margin-left: -4px;
  }

  .pills span {
    display: inline-block;
    padding: 4px 8px;
    margin: 4px;
    border-radius: 4px;
  }

</style>
